import { HttpClient, HttpHeaders, HttpRequest, HttpEventType, HttpResponse, HttpProgressEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseResponseDTO } from "@app/shared/dto/base-responseDTO";
import { MapperControlloFirma } from "@app/shared/mapper/edocumento/mapper-controllo-firma";
import { MapperBaseResponse } from "@app/shared/mapper/mapper-baseresponse";
import { ModaleErroreStore } from "@app/shared/store/modale-errore.store";
import { BaseResponseVO } from "@app/shared/vo/base-responseVO";
import { ControllaFirmaVO } from "@app/shared/vo/controlla-firmaVO";
import { StrutturaVO } from "@app/shared/vo/strutturaVO";
import { env } from "@env/environment";
import { Observable, throwError as observableThrowError } from "rxjs";
import { CheckMimeTypeResponseDTO } from "../dto/check-mimetype-responseDTO";
import { catchError, map } from "rxjs/operators";
import { ControllaFirmaDTO } from "../dto/protocollo/controlla-firmaDTO";
import { saveAs } from "file-saver";
import { FirmatarioVO } from "../vo/firmatarioVO";
import { MapperRichiestaFirma } from "../mapper/mapper-richiesta-firma";
import { RichiestaFirmaVO } from "../vo/richiesta-firmaVO";
import { DocumentoVO } from "../vo/documentoVO";
import { DownloadStatusVO } from "../vo/download-statusVO";
import { DipendenteVO } from "../vo/dipendenteVO";
import { DipendenteDTO } from "../dto/dipendenteDTO";

@Injectable({
  providedIn: "root"
})
export class ProtocolloService {
  private urlRimuoviFile = env.API_URL_BASE + env.URL_RIMUOVI_FILE;
  private urlControllaFirma = env.API_URL_BASE + env.URL_CONTROLLA_FIRMA;
  private urlExtractMimetype: string =
    env.API_URL_BASE + env.URL_CONTROLLA_MIMETYPE;
  private urlDownload = env.API_URL_BASE + env.API_DOWNLOAD_FILE;
  private urlUnitaDocumentaria = env.DOCUMENTALE_API_URL_BASE + env.URL_UNITA_DOCUMENTARIA;
  private urlDipendenti = env.API_URL_BASE + env.API_ORGANIGRAMMA_DIP;

  constructor(
    private httpClient: HttpClient,
    private mapperBaseResponse: MapperBaseResponse,
    private mapperControlloFirma: MapperControlloFirma,
    private mapperRichiestaFirma: MapperRichiestaFirma,
    private modaleErroreStore: ModaleErroreStore
  ) { }

  rimuoviFile(id: string, hash: string): Observable<void> {
    console.log("rimuovi file: ", id, " con hashDocumento: ", hash);
    return this.httpClient
      .delete(this.urlRimuoviFile + id + "?hashDocumento=" + hash)
      .pipe(
        catchError(err => {
          // this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        }),
        map(response => console.log("Rimozione Effettuata ", response))
      );
  }

  controllaFirma(id: string): Observable<ControllaFirmaVO> {
    console.log("controllaFirma ");
    return this.httpClient
      .get<ControllaFirmaDTO>(
        this.urlControllaFirma +
        id +
        "?dataConsultazione=" +
        new Date().getTime()
      )
      .pipe(
        catchError(err => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        }),
        map((response: ControllaFirmaDTO) =>
          this.mapperControlloFirma.convertDtoToVo(response)
        )
      );
  }

  downloadFile(index: string, nome: string): void {
    console.log(
      "[ProtocolloService] downloadFile index:",
      index,
      ", nome",
      nome
    );
    this.httpClient
      .get(this.urlDownload + index, {
        responseType: "blob",
        headers: new HttpHeaders({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      })
      .subscribe(
        response => {
          // download file
          // const blob = new Blob([response], { type: "application/pdf" });
          const blob = new Blob([response]);
          saveAs(blob, nome);
        },
        err => this.modaleErroreStore.sendErrore(err)
      );
  }
  async downloadArrayBufferFileProgress(documento: DocumentoVO): Promise<ArrayBuffer> {
    return new Promise<ArrayBuffer>((resolve: (value: ArrayBuffer) => void, reject: (value?: any) => void) => {
      try {
        console.log("[ProtocolloService] getDownloadedFileProgress id:", documento.idRepository, ", nome", documento.nome);
        const req = new HttpRequest("GET", this.urlDownload + documento.idRepository, {
          responseType: "arraybuffer",
          reportProgress: true,
          observe: "events"
        });
        this.httpClient.request(req).subscribe(event => {
          if (event === undefined) {
            console.log("[ProtocolloService] downloadFileProgress undefined event! ");
          } else if (event.type === HttpEventType.Sent) {
            documento.info.percentDone = 0;
          } else if (event.type === HttpEventType.DownloadProgress) {
            this.updateDownloadProgress(documento.info, event);
          } else if (event instanceof HttpResponse) {
            documento.nome = this.replaceNonConforme(documento.nome, documento.info.numeroProtocollo, documento.info.annoProtocollo);
            console.log("File is completely downloaded!");
            documento.info.percentDone = undefined;
            resolve(event.body as ArrayBuffer);
          }
        }, error => {
          console.log("ERRORE >>>>>>>>>>>>>", error);
          if (error.status == 500) {
            error.message = "L'utente non risulta autorizzato al download del file";
          }
          this.modaleErroreStore.sendErrore(error);
          documento.info.percentDone = undefined;
          reject(error);
        });
      } catch (e) {
        reject(e);
      }
    });
  }


  async downloadFileProgress(documento: DocumentoVO) {
    console.log("[ProtocolloService] downloadFileProgress id:", documento.idRepository, ", nome", documento.nome);
    const req = new HttpRequest("GET", this.urlDownload + documento.idRepository, {
      responseType: "blob",
      reportProgress: true,
      observe: "events"
    });
    return this.httpClient.request(req).subscribe(event => {
      if (event === undefined) {
        console.log("[ProtocolloService] downloadFileProgress undefined event! ");
      } else if (event.type === HttpEventType.Sent) {
        documento.info.percentDone = 0;
      } else if (event.type === HttpEventType.DownloadProgress) {
        this.updateDownloadProgress(documento.info, event);
      } else if (event instanceof HttpResponse) {
        this.saveFileLocally(event, this.replaceNonConforme(documento.nome, documento.info.numeroProtocollo, documento.info.annoProtocollo));
        console.log("File is completely downloaded!");
        documento.info.percentDone = undefined;
      }
    }, error => {
      console.log("ERRORE >>>>>>>>>>>>>", error);
      if (error.status == 500) {
        error.message = "L'utente non risulta autorizzato al download del file";
      }
      this.modaleErroreStore.sendErrore(error);
      documento.info.percentDone = undefined;
    });
  }

  private saveFileLocally(event: HttpResponse<any>, nome: string) {
    const res: any = event.body;
    const url = window.URL.createObjectURL(res);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.setAttribute("style", "display: none");
    a.href = url;
    a.download = nome;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }


  private updateDownloadProgress(downloadStatus: DownloadStatusVO, event: HttpProgressEvent) {
    downloadStatus.percentDone = Math.round((100 * event.loaded) / event.total);
    downloadStatus.currTime = new Date().getTime();
    // setting start time
    if (downloadStatus.percentDone === 0) {
      downloadStatus.startTime = new Date().getTime();
      downloadStatus.prevTime = downloadStatus.startTime;
    }
    // tracking how much data is received
    downloadStatus.bytesReceied = event.loaded / 1000000;
    // calculating download speed per percent data received
    downloadStatus.speed =
      (downloadStatus.bytesReceied - downloadStatus.oldbytes) /
      ((downloadStatus.currTime - downloadStatus.prevTime) / 1000);
    if (downloadStatus.speed < 1) {
      downloadStatus.unit = "Kbps";
      downloadStatus.speed *= 1000;
    } else {
      downloadStatus.unit = "Mbps";
    }
    // updating previous values
    downloadStatus.prevTime = downloadStatus.currTime;
    downloadStatus.oldbytes = downloadStatus.bytesReceied;
    // calculating avg download speed
    if (downloadStatus.percentDone === 100) {
      downloadStatus.endTime = new Date().getTime();
      let duration = (downloadStatus.endTime - downloadStatus.startTime) / 1000;
      let mbps = event.total / duration / 1000000;
      if (mbps < 1) {
        downloadStatus.speed = event.total / duration / 1000;
        downloadStatus.unit = "Kbps";
      } else {
        downloadStatus.speed = mbps;
        downloadStatus.unit = "Mbps";
      }
    }
  }

  private replaceNonConforme(
    fileName: string,
    numeroProtocollo: string,
    annoProtocollo: string
  ): string {
    let newName = fileName;
    if (
      fileName != null &&
      numeroProtocollo != null &&
      annoProtocollo != null &&
      fileName.toUpperCase().startsWith("NONCONFORME")
    ) {
      if (fileName.toUpperCase() === "NONCONFORME.EML") {
        const prefix = "Prot." + numeroProtocollo + "_" + annoProtocollo + "_";
        newName = prefix + fileName;
      } else {
        const prefix = "Prot." + numeroProtocollo + "_" + annoProtocollo + "_";
        newName = prefix + fileName.replace("NonConforme-", "");
      }
    } else if (fileName != null &&
      fileName.toUpperCase().startsWith("DATISEGNATURA_NONCONFORME")) {
      const prefix = "Prot." + numeroProtocollo + "_" + annoProtocollo + "_";
      newName = fileName.replace("DatiSegnatura_", "");
      newName = "DatiSegnatura_" + prefix + newName.replace("NonConforme-", "");
    }

    if (newName.endsWith("pdf.pdf")) {
      newName = newName.replace(".pdf", "");
    }
    return newName;
  }


  controllaMimetype(id: string): Observable<string> {
    console.log("[ProtocolloService.controllaMimetype] id documento:" + id);
    return this.httpClient
      .get<CheckMimeTypeResponseDTO>(this.urlExtractMimetype + id)
      .pipe(
        catchError(err => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        }),
        map((response: CheckMimeTypeResponseDTO) => response.descrizione)
      );
  }

  richiestaFirma(
    idUd: string,
    richiestaFirma: RichiestaFirmaVO
  ): Observable<BaseResponseVO> {
    return this.httpClient
      .post<BaseResponseDTO>(
        this.urlUnitaDocumentaria +
        idUd +
        "/richiesta-firma",
        this.mapperRichiestaFirma.convertVoToDto(richiestaFirma)
      )
      .pipe(
        catchError(err => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        }),
        map((response: BaseResponseDTO) =>
          this.mapperBaseResponse.convertDtoToVo(response)
        )
      );
  }

  cancellaFirma(idUd: string, idDocumento: string): Observable<BaseResponseVO> {
    return this.httpClient
      .delete<BaseResponseDTO>(
        this.urlUnitaDocumentaria +
        idUd +
        "/richiesta-firma/" +
        idDocumento
      )
      .pipe(
        map((response: BaseResponseDTO) =>
          this.mapperBaseResponse.convertDtoToVo(response)
        ),
        catchError(err => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }


  getDipendenti(nome: String): Observable<DipendenteVO[]> {

    return this.httpClient
      .get(this.urlDipendenti + "ricerca?filtro=" + nome)
      .pipe(
        map((response: DipendenteDTO[]) =>
          this.convertDataDip(response)
        ),
        catchError(_ => Observable.of([]))
      );
  }

  private convertDataDip(dipendenti: DipendenteDTO[]) {

    let dipendentiVO: DipendenteVO[];

    console.log("numero risultati: " + dipendenti.length);
    dipendentiVO = new Array<DipendenteVO>();
    dipendenti.forEach(element => {
      const dipendenteVO = new DipendenteVO();
      dipendenteVO.cognome = element.cognome;
      dipendenteVO.nome = element.nome;
      dipendenteVO.cf = element.cf;
      dipendenteVO.cmu = element.cmu;
      dipendenteVO.descrizioneCmu = element.descrizioneCmu;
      dipendenteVO.codiceEnte = element.codiceEnte;
      dipendenteVO.matricola = element.matricola;
      dipendenteVO.output = element.cognome + " " + element.nome;
      let search: DipendenteVO[];
      search = dipendentiVO.filter(
        dipendente => dipendente.cf === element.cf
      );
      if (search.length === 0) {
        dipendentiVO.push(dipendenteVO);
      }
    });
    return dipendentiVO;
  }

}
